// extracted by mini-css-extract-plugin
module.exports = {"hightlighting":"LogMessageSearchHighlighting__hightlighting--Zz","bright":"LogMessageSearchHighlighting__bright--uU"};